import CategoryDetails from '../category-details/CategoryDetails';
import CategoryImage from '../category-image/CategoryImage';
import getUrlPath from '../../../utils/getUrlPath';
import { url } from '../../../constants/url';

interface CategoryCardProps {
  slug?: string;
}

function CategoryCard({ slug }: CategoryCardProps) {
  return (
    <a
      className='category-card-wrapper category-card'
      href={`${getUrlPath(url.rental.subPath.categories)}/${slug}`}
    >
      <div className='content-container'>
        <div className='category-card-image-wrapper'>
          <div className='category-card-skeleton-wrap'>
            <div className='category-card-skeleton category-page-card-image-skeleton'></div>
          </div>
          <div className='category-card-image-placeholder'>
            <CategoryImage slug={slug} />
          </div>
        </div>
        <div className='category-card-details-wrapper'>
          <div className='category-card-skeleton-wrap category-card-subtitle-skeleton-wrap'>
            <div className='category-card-skeleton category-card-subtitle-skeleton'></div>
            <div className='category-card-skeleton category-card-title-skeleton'></div>
          </div>
          <div className='category-card-details-placeholder'>
            <CategoryDetails slug={slug} />
          </div>
        </div>
      </div>
    </a>
  );
}

export default CategoryCard;
